export const isImportSuccessful = result => {
  if (!result) return false

  return !result.file_error && result.error_rows === 0
}
